import React, { useState } from "react";
import { Box, Typography, TextField, Button, Grid } from "@mui/material";
import StarIcon from "@mui/icons-material/Star";
import { toast } from "react-toastify";
import axios from "axios";
import { theme } from "../../Assets/Theme/theme";
import { BASE_URL } from "../../Assets/Constants";

function Reviews({ data, onCommentPosted }) {
  const loginData = JSON.parse(localStorage.getItem("loginData"));
  const token = loginData?.token;
  const [rating, setRating] = useState(0);
  const [comment, setComment] = useState("");
  const [visibleReviews, setVisibleReviews] = useState(2);
  const [loading, setLoading] = useState(false);
  const [reviews, setReviews] = useState(data.ratings);
  const handleCommentChange = (e) => setComment(e.target.value);

  const handlePostComment = async () => {
    const experienceId = data?._id;
    if (!experienceId) {
      console.error("Experience ID is missing!");
      return;
    }

    const payload = { rating, comment };

    try {
      setLoading(true);
      const response = await axios.post(
        `${BASE_URL}/user/experiences/${experienceId}/rating`,
        payload,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      toast.success(response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
        style: { backgroundColor: 'orange', color: 'white' },
      });

      setComment("");
      setRating(4);
      if (onCommentPosted) {
        onCommentPosted();
      }
    } catch (error) {
      if (onCommentPosted) {
        onCommentPosted();
      }
      console.error("Error posting comment:", error?.response?.data?.message);
      toast.error(error?.response?.data?.message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleLoadMore = () => {
    setVisibleReviews((prev) => prev + 2);
  };

  if (loading) {
    return (
      <>
        <style>{loaderStyle.spinnerAnimation}</style>
        <div style={loaderStyle.loaderContainer}>
          <div style={loaderStyle.spinner}></div>
        </div>
      </>
    );
  }

  const calculateAverageRating = () => {
    if (reviews?.length === 0) return 0;
    const totalRating = reviews?.reduce((sum, item) => sum + item.rating, 0);
    return (totalRating / reviews?.length).toFixed(0);
  };

  return (
    <Box sx={{ mt: 4 }}>
      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          <Box>
            <Box
              sx={{
                display: "flex",
                alignItems: "center",
                mb: 2,
                justifyContent: "space-between",
              }}
            >
              <Typography sx={{ fontWeight: 600, fontSize: "20px" }}>
                Reviews
              </Typography>
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography
                  sx={{
                    color: "#000",
                    fontSize: "1.5rem",
                    fontWeight: "600",
                    mr: 1,
                  }}
                >
                  {calculateAverageRating()}/5
                </Typography>
                {[...Array(5)]?.map((_, index) => (
                  <StarIcon
                    key={index}
                    sx={{
                      color:
                        index < Math.round(calculateAverageRating())
                          ? "#FFC107"
                          : "#E0E0E0",
                      fontSize: "1.5rem",
                    }}
                  />
                ))}
              </Box>
            </Box>
            {reviews?.slice(0, visibleReviews)?.map((rating) => {
              console.log(rating?.user?.email?.split('@')[0], "RATING");
              
              return (
                <Box key={rating._id} sx={{ mb: 3 }}>
                  <Box
                    sx={{ display: "flex", alignItems: "center", mb: 1, gap: 2 }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{ fontWeight: 500, color: theme.colors.text }}
                    >
                      {rating?.user?.user || "Anonymous"}
                    </Typography>
                    <Box sx={{ display: "flex", alignItems: "center" }}>
                      {[...Array(5)]?.map((_, i) => (
                        <StarIcon
                          key={i}
                          sx={{
                            color: i < rating.rating ? "#FFC107" : "#E0E0E0",
                            fontSize: "1rem",
                          }}
                          aria-label={i < rating.rating ? "Filled star" : "Empty star"}
                        />
                      ))}
                    </Box>
                  </Box>
                  <Typography
                    sx={{ color: theme.colors.textLight, lineHeight: "1.6" }}
                  >
                    {rating?.comment || "No comment provided."}
                  </Typography>
                </Box>
              );
            })}


            <Typography
              sx={{ color: theme.colors.textLight, lineHeight: "1.6" }}
            >
              {reviews?.length == 0 && "No comment provided."}
            </Typography>


            {visibleReviews < reviews?.length && (
              <Typography
                variant="body2"
                sx={{
                  color: theme.colors.orange,
                  fontWeight: 600,
                  cursor: "pointer",
                  mt: 2,
                  textAlign: "center",
                }}
                onClick={handleLoadMore}
              >
                More Reviews
              </Typography>
            )}
          </Box>
        </Grid>

        {token && <Grid item xs={12} md={6}>
          <Box sx={{ p: 3, borderRadius: "8px" }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
              Rate this Experience
            </Typography>
            <Box sx={{ display: "flex", alignItems: "center", mb: 2 }}>
              {[...Array(5)]?.map((_, index) => (
                <StarIcon
                  key={index}
                  sx={{
                    color: index < rating ? "#FFC107" : "#E0E0E0",
                    fontSize: "1.5rem",
                    cursor: "pointer",
                  }}
                  onClick={() => setRating(index + 1)}
                />
              ))}
            </Box>
            <Typography
              sx={{ fontWeight: 600, fontSize: "16px", marginBottom: "10px" }}
            >
              Comment
            </Typography>
            <TextField
              placeholder="Comment"
              multiline
              rows={3}
              value={comment}
              onChange={handleCommentChange}
              fullWidth
              sx={{
                mb: 2,
                "& .MuiOutlinedInput-root": {
                  borderRadius: "8px",
                  "& fieldset": {
                    borderColor: "#BDBDBD",
                  },
                  "&:hover fieldset": {
                    borderColor: "#BDBDBD",
                  },
                  "&.Mui-focused fieldset": {
                    borderColor: "#BDBDBD",
                  },
                },
              }}
            />
            <Button
              variant="contained"
              sx={{
                backgroundColor: theme.colors.orange,
                textTransform: "none",
                fontWeight: "600",
                marginLeft: "auto",
                display: "block",
                fontSize: "18px",
                "&:hover": {
                  color: "#fff",
                  backgroundColor: "#e65500"
                },
              }}
              onClick={handlePostComment}
            >
              Post Comment
            </Button>
          </Box>
        </Grid>}
      </Grid>
    </Box>
  );
}

const loaderStyle = {
  loaderContainer: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    height: "100vh",
    backgroundColor: "#f9f9f9",
  },
  spinner: {
    width: "50px",
    height: "50px",
    border: "5px solid rgba(0, 0, 0, 0.1)",
    borderTop: "5px solid #FF7900",
    borderRadius: "50%",
    animation: "spin 1s linear infinite",
  },
  spinnerAnimation: `
    @keyframes spin {
      0% {
        transform: rotate(0deg);
      }
      100% {
        transform: rotate(360deg);
      }
    }
  `,
};

export default Reviews;
